/** @file descendantsOf: every node below a node in a puppet's default tree (children, their children...). */

/** The names whose parent chain reaches `node` (not `node` itself), in node order. */
export function descendantsOf(nodes: Readonly<Record<string, { parent?: string }>>, node: string): string[] {
  const below = (name: string): boolean => {
    const seen = new Set<string>();
    let p = nodes[name]?.parent;
    while (p !== undefined && !seen.has(p)) {
      if (p === node) return true;
      seen.add(p);
      p = nodes[p]?.parent;
    }
    return false;
  };
  return Object.keys(nodes).filter(below);
}
